import React, { useEffect, useState } from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { Box, useTheme } from '@mui/material'

import './style.css'
import ToDoCard from './Component/Card/ToDoCard'
import ObjectIfsCard from './Component/Card/ObjectIfsCard'
import SuiviDuTemps from './Component/Card/SuiviDuTemps'
import MonCalander from './Component/Card/MonCalander'
import ReparitionCard from './Component/Card/ReparitionCard'
import SuggestionDeTaches from './Component/Card/SuggestionDeTaches'
import AvancementProjetCard from './Component/Card/AvancementProjetCard'
import ConseilsCard from './Component/Card/ConseilsCard'
import { makeGetRequest } from 'utils/api'
const ResponsiveGridLayout = WidthProvider(Responsive)

function SyntheseTemps() {
  const theme = useTheme()
  const [reports, setReports] = useState([])
  useEffect(() => {
    getSyntheseTempsReports()
  }, [])
  const getSyntheseTempsReports = async () => {
    const { data } = await makeGetRequest('/api/general/synthese-temps-reports/', {}, true)
    setReports([...data])
  }
  const layout1 = [
    { i: '1', x: 0, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 3, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 6, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 9, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 6, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 9, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layout2 = [
    { i: '1', x: 0, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 5, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 5, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 5, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 5, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layout3 = [
    { i: '1', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layout4 = [
    { i: '1', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layouts = { lg: layout1, md: layout2, sm: layout3, xs: layout4 }

  const children = React.useMemo(() => {
    const xArr = [0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9]
    return (
      reports &&
      reports.map((val, idx) => (
        <div
          key={idx}
          style={{ backgroundColor: theme.palette.appBar.main, display: 'grid' }}
          data-grid={{
            x: xArr[idx],
            y: Infinity,
            w: 3,
            h: 3,
            minW: 2,
            maxW: 8,
            minH: 3,
            maxH: 10,
          }}
        >
          {val.type === 'todo' && (
            <ToDoCard updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'objectifs' && (
            <ObjectIfsCard updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'suividutemps' && (
            <SuiviDuTemps updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'moncalender' && (
            <MonCalander updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'reparition' && (
            <ReparitionCard updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'suggestion' && (
            <SuggestionDeTaches updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'avancement' && (
            <AvancementProjetCard updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
          {val.type === 'conseils' && (
            <ConseilsCard updateReports={getSyntheseTempsReports} oldData={val.data} />
          )}
        </div>
      ))
    )
  }, [reports])

  return (
    <Box maxWidth={1650} ml={'auto'} mr={'auto'}>
      <ResponsiveGridLayout
        className="layout"
        style={{ margin: '10px' }}
        autoSize={true}
        layouts={layouts}
        useCSSTransforms={true}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
        draggableCancel=".no-drag"
      >
        {children}
      </ResponsiveGridLayout>
    </Box>
  )
}

export default SyntheseTemps
